import ManagerProfileRepository from '../ports/ManagerProfileRepository';
import { ManagerProfile } from '../../domain/ManagerProfile';

const getMyManagerProfile =
  ({ managerProfileRepository }: { managerProfileRepository: ManagerProfileRepository }) =>
  (): Promise<ManagerProfile> =>
    managerProfileRepository.getMyProfile();

export default getMyManagerProfile;
